module.exports = __webpack_public_path__ + "static/media/img1.45cc336f.jpg";